import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import SingleHeroVideoWistia from './components/SingleHeroVideoWistia';
import SingleHeroVideoVimeo from './components/SingleHeroVideoVimeo';
const SingleHeroVideo = t0 => {
  const $ = _c(12);
  const {
    config: t1,
    isAdmin
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    videoProps,
    heading,
    displayVideoTitle
  } = t2;
  const isTitleVisible = displayVideoTitle?.enabled === "Show" && !!heading?.content;
  let t3;
  if ($[2] !== heading?.content || $[3] !== isTitleVisible) {
    t3 = isTitleVisible ? <div className="w-full text-left font-sans text-[1.2rem] font-bold tracking-[-1px] leading-[2rem] text-gray min-h-[2rem]">{heading?.content}</div> : null;
    $[2] = heading?.content;
    $[3] = isTitleVisible;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isAdmin || $[6] !== videoProps?.autoplay || $[7] !== videoProps?.videoID) {
    t4 = !!videoProps?.videoID && videoProps?.videoID.startsWith("http") !== true ? <SingleHeroVideoWistia videoId={videoProps?.videoID} isAdmin={isAdmin} autoplay={videoProps?.autoplay === "Show"} /> : <SingleHeroVideoVimeo videoId={videoProps?.videoID} autoplay={videoProps?.autoplay === "Show"} />;
    $[5] = isAdmin;
    $[6] = videoProps?.autoplay;
    $[7] = videoProps?.videoID;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <FixedWidthContainer className="overflow-hidden relative min-h-[100px]">{t3}{t4}</FixedWidthContainer>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
SingleHeroVideo.propTypes = {
  config: PropTypes.shape({
    videoProps: PropTypes.shape({
      videoID: PropTypes.string,
      autoplay: PropTypes.string
    })
  }),
  isAdmin: PropTypes.bool
};
export default SingleHeroVideo;